import 'babel-polyfill';

import Vue from 'vue';
import { currency } from './filters/common';
import 'normalize.css/normalize.css';
import { handlePromiseReject } from '@/utils/globalEvent'
import { externalCallFunc } from '@/utils/webviewUtils';
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import App from './App';
import router from './router';
import store from './store';
import api_ys from './api/getApi';
import VueClipboard from 'vue-clipboard2';
import './permission';
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import DatetimePlugin from 'vux/src/plugins/datetime/index.js'

import uploader from 'vue-simple-uploader'; 
import VueScroller from 'vue-scroller'
import Api from '@/request/api';

import 'vant/lib/index.css'

Vue.use(VueScroller);

Vue.prototype.$Api = Api;
Vue.prototype.$externalCallFunc = externalCallFunc;
handlePromiseReject();


import VueAwesomeSwiper from 'vue-awesome-swiper';
const PluginList = [uploader, VueClipboard, VueAwesomeSwiper, ToastPlugin, LoadingPlugin, DatetimePlugin];
PluginList.forEach(item => {
if (item === ToastPlugin) {
Vue.use(item, { position: 'middle', type: 'text' });
}
else {
Vue.use(item);
}
});
Vue.directive('transfer-dom', TransferDom);

import 'lib-flexible';
Vue.filter('currency', currency);


/* 2020-12-16 修复部分机型软键盘出现页面上移无法回滚*/
window.addEventListener('resize', () => {
const activeElement = document.activeElement
if (activeElement.tagName === 'INPUT' ||
activeElement.tagName === 'TEXTAREA') {
setTimeout(() => {
activeElement.scrollIntoView()
}, 100)
}
})


/* 微信6.7.4 H5页面里的select,input软键盘弹起的时候页面会上移 */
import {
is_weixn
} from '@/utils/index'

Vue.directive('input-dom', {
inserted: function (el) {

el.addEventListener('blur', () => {
window.scrollTo(0, 0)
})

}
});

/* ios input软键盘弹起遮挡fix定位元素 */
Vue.directive('fix-input', {
inserted: function (el) {
el.addEventListener('focus', () => {
var u = navigator.userAgent,
app = navigator.appVersion;
var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); 
if (isiOS) {
window.setTimeout(scrollBottom, 500);
}
})

function scrollBottom() {
const body = document.querySelector('#app') 
window.scrollTo(0, body.scrollHeight);
}
}
});

/* 禁止元素滚动事件 -- 解决滚动穿透问题：适用于不包含滚动元素的dom元素*/
Vue.directive('touchForbid', {
bind: function (el, binding, vnode) {
el.addEventListener('touchmove', (e) => {

e.stopPropagation();
let scrollEl = e.currentTarget;

if (scrollEl.scrollHeight >= scrollEl.offsetHeight) {

e.preventDefault();
}
}, false);
}
});









Vue.config.productionTip = false;
window.ysEventBus = new Vue();

Vue.prototype.$api_ys = api_ys;

Vue.config.devtools = true;

router.afterEach((to,from) => {
console.log(location,from,to);


let origin = sessionStorage.getItem('origin');
if (!origin) {
origin = localStorage.getItem("origin");
}
if (from.fullPath !== to.fullPath) {

if (origin === 'android') { // android
externalCallFunc({
funcName: "updateHistoryState",
params: {
webUrl: location.origin + to.fullPath,
},
});
}
}


});

new Vue({
el: '#app',
router: router,
store,
template: '<App/>',
components: { App }
});




// WEBPACK FOOTER //
// ./src/main.js